<template>
  <div class="periodpicker-years" style="display: block">
    <!-- <table> -->
    <PeriodPickerHeader
      :header-text="headerText"
      :has-next-page="hasNextPage"
      :has-previous-page="hasPreviousPage"
      @show-next-page="showNextPage"
      @show-previous-page="showPreviousPage"
      @headerClick="handleHeaderClick"
    />
    <div
      v-for="(row, row_index) in yearsInRows"
      :key="`year-row-${row_index}`"
      class="periodpicker-years-row"
    >
      <span
        v-for="(year, year_index) in row"
        :key="`year-${year_index}`"
        :class="yearClasses(year)"
        class="period-picker-item"
        @click="handleYearClick(year)"
      >
        {{ year.label }}
        <i
          v-show="hasPrivatePeriods(year) && hasPeriodsWithData(year)"
          class="icon-eye-slash"
        />
      </span>
    </div>
  </div>
</template>

<script>
import chunk from 'lodash/chunk'
import classNames from 'classnames'
import includes from 'lodash/includes'
import isEqual from 'lodash/isEqual'

import PeriodPickerHeader from './period-picker-header'
import PeriodPickerMixin from './period-picker-mixin'

const PeriodPickerYears = {
  components: {
    PeriodPickerHeader,
  },
  mixins: [PeriodPickerMixin],
  props: {
    years: Array,
    highlightedYear: Object,
  },
  emits: ['year-click', 'header-click'],
  data() {
    const pages = chunk(this.years, 10)
    const currentPage =
      pages.findIndex((yearsOnPage) =>
        includes(yearsOnPage, this.highlightedYear)
      ) || 0

    return {
      currentPage,
    }
  },
  computed: {
    currentPageData() {
      return this.pages[this.currentPage]
    },
    firstYearOnPage() {
      return this.currentPageData[0]
    },
    hasPreviousPage() {
      return this.currentPage > 0
    },
    hasNextPage() {
      return this.currentPage < this.pages.length - 1
    },
    headerText() {
      return `${this.firstYearOnPage.label}-${this.lastYearOnPage.label}`
    },
    lastYearOnPage() {
      return this.currentPageData[this.currentPageData.length - 1]
    },
    nextYearClass() {
      return classNames({
        'not-visible': !this.hasNextPage,
      })
    },
    pages() {
      return chunk(this.years, 10)
    },
    previousYearClass() {
      return classNames({
        'not-visible': !this.hasPreviousPage,
      })
    },
    yearsInRows() {
      return chunk(this.currentPageData, 2)
    },
  },
  methods: {
    yearClasses(year) {
      const disabled = !this.hasPeriodsWithData(year)

      return classNames({
        year: true,
        private: this.hasPrivatePeriods(year) && !disabled,
        active: isEqual(year, this.highlightedYear),
        disabled,
      })
    },
    showPreviousPage() {
      if (this.hasPreviousPage) {
        this.currentPage = this.currentPage - 1
      }
    },
    showNextPage() {
      if (this.hasNextPage) {
        this.currentPage = this.currentPage + 1
      }
    },
    handleYearClick(year) {
      if (this.hasPeriodsWithData(year)) {
        this.$emit('year-click', { year: year })
      }
    },
    handleHeaderClick() {
      this.$emit('header-click')
    },
  },
}

export default PeriodPickerYears
</script>
